export const TOURNAMENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  DELETED: 'deleted'
} as const;

export const TOURNAMENT_STATUS_LABELS = {
  [TOURNAMENT_STATUS.DRAFT]: 'Черновик',
  [TOURNAMENT_STATUS.PUBLISHED]: 'Опубликован',
  [TOURNAMENT_STATUS.IN_PROGRESS]: 'В процессе',
  [TOURNAMENT_STATUS.COMPLETED]: 'Завершен',
  [TOURNAMENT_STATUS.DELETED]: 'Удален'
} as const;

export type TournamentStatus = typeof TOURNAMENT_STATUS[keyof typeof TOURNAMENT_STATUS];

export const TOURNAMENT_STATUS_COLORS = {
  [TOURNAMENT_STATUS.DRAFT]: {
    color: '#d48806',
    backgroundColor: '#fffbe6',
    borderColor: '#ffe58f'
  },
  [TOURNAMENT_STATUS.PUBLISHED]: {
    color: '#096dd9',
    backgroundColor: '#e6f7ff',
    borderColor: '#91d5ff'
  },
  [TOURNAMENT_STATUS.IN_PROGRESS]: {
    color: '#08979c',
    backgroundColor: '#e6fffb',
    borderColor: '#87e8de'
  },
  [TOURNAMENT_STATUS.COMPLETED]: {
    color: '#389e0d',
    backgroundColor: '#f6ffed',
    borderColor: '#b7eb8f'
  },
  [TOURNAMENT_STATUS.DELETED]: {
    color: '#cf1322',
    backgroundColor: '#fff1f0',
    borderColor: '#ffa39e'
  }
} as const;

export const FILE_UPLOAD_CONFIG = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  MIME_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png'
  ],
  ALLOWED_EXTENSIONS: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'],
} as const;

export const TOURNAMENT_VALIDATION_RULES = {
  name: {
    min: 3,
    max: 100,
  },
  description: {
    max: 2000,
  },
  participants: {
    min: 2,
    max: 1000,
  },
} as const;
